"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Represents any "at" rule:
 *
 * ```
 * '@media screen': {
 *   'fontSize': 14,
 *   ':hover': {
 *     color: 'pink',
 *   },
 *   '@media (max-width: 12cm)': {
 *     color: 'blue',
 *   },
 * },
 * ```
 *
 *   ↓ ↓ ↓
 *
 * ```
 * {
 *   name: '@media screen',
 *   nodes: [
 *     StyleCollectorNode,
 *     StyleCollectorPseudoNode,
 *     StyleCollectorAtNode,
 *   ],
 * }
 * ```
 */
var StyleCollectorAtNode = /*#__PURE__*/function () {
  function StyleCollectorAtNode(atRuleName, nodes) {
    (0, _classCallCheck2.default)(this, StyleCollectorAtNode);
    (0, _defineProperty2.default)(this, "atRuleName", void 0);
    (0, _defineProperty2.default)(this, "nodes", void 0);
    this.atRuleName = atRuleName;
    this.nodes = nodes;
  }

  (0, _createClass2.default)(StyleCollectorAtNode, [{
    key: "addNodes",
    value: function addNodes(nodes) {
      this.nodes = new Map([].concat((0, _toConsumableArray2.default)(this.nodes), (0, _toConsumableArray2.default)(nodes)));
    }
  }, {
    key: "getAtRuleName",
    value: function getAtRuleName() {
      return this.atRuleName;
    }
  }, {
    key: "printNodes",
    value: function printNodes(config) {
      var output = '';
      this.nodes.forEach(function (node) {
        output += node.printNodes(_objectSpread(_objectSpread({}, config), {}, {
          bumpSpecificity: true
        })).join('');
      });
      return ["".concat(this.atRuleName, "{").concat(output, "}")];
    }
  }]);
  return StyleCollectorAtNode;
}();

exports.default = StyleCollectorAtNode;